<template>
  <h2>Terminais</h2>
  <div class="row">
    <div class="col-12">
      <nav id="tabs" class="nav">
        <a class="nav-link" @click="selectedTab = 1" :class="selectedTab == 1 ? 'active' : ''">Listagem</a>
        <a class="nav-link" @click="terminal.id ? selectedTab = 2 : createTerminal()" :class="selectedTab == 2 ? 'active' : ''">Cadastro</a>
      </nav>
      <div v-show="loading">Carregando...</div>
      <table class="styled-table" v-show="selectedTab == 1 && !loading">
        <thead>
          <tr>
            <th style="width: 140px">
              <input type="text" v-model="quickFilter" class="form-control" style="height: 26px" placeholder="Pesquisar" autocomplete="off" />
            </th>
            <th>Key</th>
            <th>Tipo</th>
            <th>Vendedor</th>
            <th>Ativo</th>
            <th><button type="button" class="btn btn-primary" @click="createTerminal()">Adicionar</button></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="t in terminals" :key="t.id" v-show="runQuickFilter(t)">
            <td colspan="2">{{ t.key }}</td>
            <td>{{ t.type }}</td>
            <td>{{ t.seller ? t.seller.name : "" }}</td>
            <td><i v-if="t.isActive" class="fa-solid fa-check"></i></td>
            <td>
              <i class="fa-solid fa-pen-to-square" @click="editTerminal(t)"></i>
              <i class="fa-solid fa-trash" @click="deleteTerminal(t.id)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="form" style="max-width: 500px" v-show="selectedTab == 2">
      <h5>Cadastro</h5>
      <br />
      <div class="input-group mb-3">
        <span class="input-group-text">Key</span>
        <input class="form-control" type="text" v-model="terminal.key" />
      </div>
      <div class="input-group mb-3">
        <span class="input-group-text">Tipo</span>
        <select class="form-select" v-model="terminal.type">
          <option :selected="terminal.type == 'Mobile'" value="Mobile">Mobile</option>
          <option :selected="terminal.type == 'POS'" value="POS">POS</option>
        </select>
      </div>
      <div class="input-group mb-3">
        <span class="input-group-text">Vendedor</span>
        <select class="form-select" v-model="terminal.sellerId">
          <option :selected="terminal.sellerId == s.id" v-for="s in sellers" :key="s.id" :value="s.id">{{ s.name }}</option>
        </select>
      </div>
      <div>
        <input type="checkbox" value="" id="flexCheckDefault" v-model="terminal.isActive" />
        <label class="form-check-label" for="flexCheckDefault" style="float: left">Ativo</label>
      </div>
      <br />
      <button type="button" class="btn btn-primary" @click="terminal.id ? updateTerminal() : insertTerminal()">Salvar</button>
      <button type="button" class="btn btn-secondary" style="margin-left: 5px" @click="reset()">Cancelar</button>
    </div>
  </div>
</template>
<script>
import mainService from "@/services/mainService";
import { toast } from "@/composables/useToast";
import { handleErrorMessage } from "@/services/config";
export default {
  data: () => ({
    quickFilter: "",
    terminals: [],
    sellers: [],
    terminal: {},
    selectedTab: 1,
    loading: false,
    currentRegion: null,
  }),
  mounted() {
    this.currentRegion = JSON.parse(localStorage.getItem("currentRegion"));
    
    // Verificar se é ADMIN - eles podem ver sem região selecionada
    const currentUser = JSON.parse(localStorage.getItem("user"));
    if (this.currentRegion || (currentUser && currentUser.role === 0)) {
      this.searchTerminals();
    } else {
      toast.error("Selecione uma região!");
    }
    
    // Listener para mudanças na região selecionada
    window.addEventListener('storage', (e) => {
      if (e.key === 'currentRegion') {
        this.currentRegion = JSON.parse(localStorage.getItem("currentRegion"));
        this.searchTerminals();
      }
    });
  },
  
  beforeUnmount() {
    // Remover listener ao destruir o componente
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    createTerminal() {
      this.terminal = { isActive: false };
      this.selectedTab = 2;
      this.currentRegion = JSON.parse(localStorage.getItem("currentRegion"));
      this.searchSellers();
    },
    editTerminal(terminal) {
      this.terminal = terminal;
      this.selectedTab = 2;
      this.searchSellers();
    },
    reset() {
      this.terminal = {};
      this.selectedTab = 1;
    },
    validateTerminal() {
      if (
        this.terminal.key == null ||
        this.terminal.key == "" ||
        this.terminal.type == null ||
        this.terminal.type == "" ||
        this.terminal.isActive == null
      ) {
        toast.error("Por favor, preencha todos os campos!");
        return false;
      }
      return true;
    },
    searchTerminals() {
      const currentRegion = JSON.parse(localStorage.getItem("currentRegion"));
      const currentUser = JSON.parse(localStorage.getItem("user"));
      
      // Para ADMIN, permitir visualização mesmo sem região selecionada
      if (currentUser && currentUser.role === 0) { // ADMIN
        this.loading = true;
        let regionId = currentRegion ? currentRegion.id : null;
        
        mainService
          .searchTerminalsByRegion(regionId)
          .then((terminals) => {
            this.terminals = terminals.data;
          })
          .catch((error) => {
            toast.error(handleErrorMessage(error));
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (currentRegion) {
        // Para outros usuários, exigir região selecionada
        this.loading = true;
        mainService
          .searchTerminalsByRegion(currentRegion.id)
          .then((terminals) => {
            this.terminals = terminals.data;
          })
          .catch((error) => {
            toast.error(handleErrorMessage(error));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        toast.error("Por favor, selecione uma região!");
      }
    },
    insertTerminal() {
      if (this.validateTerminal()) {
        this.terminal.regionId = this.currentRegion.id;
        mainService
          .insertTerminal(this.terminal)
          .then(() => {
            toast.success("Terminal cadastrado com sucesso!");
            this.terminal = {};
            this.searchTerminals();
            this.selectedTab = 1;
          })
          .catch((error) => {
            toast.error(handleErrorMessage(error));
          })
          .finally(() => {});
      }
    },
    updateTerminal() {
      if (this.validateTerminal()) {
        mainService
          .updateTerminal(this.terminal)
          .then(() => {
            toast.success("Terminal atualizado com sucesso!");
            this.terminal = {};
            this.searchTerminals();
            this.selectedTab = 1;
          })
          .catch((error) => {
            toast.error(handleErrorMessage(error));
          })
          .finally(() => {});
      }
    },
    deleteTerminal(idTerminal) {
      this.$confirm({
        message: "Confirma a exclusão?",
        button: { no: "Não", yes: "Sim" },
        callback: (confirm) => {
          if (confirm) {
            mainService
              .deleteTerminal(idTerminal)
              .then(() => {
                toast.success("Terminal excluído com sucesso!");
                this.searchTerminals();
                this.selectedTab = 1;
              })
              .catch((error) => {
                toast.error(handleErrorMessage(error));
              })
              .finally(() => {});
          }
        },
      });
      setTimeout(() => {
        document.getElementsByClassName("vc-btn left")[0].focus();
      }, 1);
    },
    searchSellers() {
      mainService
        .searchSellers()
        .then((sellers) => {
          this.sellers = sellers.data;
        })
        .catch((error) => {
          toast.error("Erro ao consultar os Vendedores!");
        });
    },
    runQuickFilter(row) {
      let quickFilter = this.quickFilter.toUpperCase()
      return (
           row.key.toUpperCase().match(quickFilter) != null
        || row.type.toUpperCase().match(quickFilter) != null  
        || row.seller.name.toUpperCase().match(quickFilter) != null
        || (quickFilter == "ATIVO" && row.isActive)
        || (quickFilter == "INATIVO" && !row.isActive)
        )
    }
  },
};
</script>
<style scoped>
input[type="checkbox"] {
  float: left;
  margin-right: 5px;
}
</style>
